import { constants as constantsBackend } from '../features/Backend'
import { localeChanged, serverProfilesChanged, processChanged } from '../actions'

const FeatureMiddleware = store => next => (action) => {
    switch (action.type) {
        case constantsBackend.LOCALE_CHANGED: {
            const result = next(action)
            store.dispatch(localeChanged(action.payload.newLocale))
            return result
        }

        case constantsBackend.SERVER_PROFILES_CHANGED: {
            const result = next(action)
            store.dispatch(serverProfilesChanged(action.payload.serverId, action.payload.profiles))
            return result
        }

        case constantsBackend.PROCESS_CHANGED: {
            const result = next(action)
            store.dispatch(processChanged(action.payload))
            return result
        }

        default:
            return next(action)
    }
}

export default FeatureMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/FeatureMiddleware.js